import { gql } from '@apollo/client';

const UpdateReferralStatus = gql`
  mutation UpdateReferralStatus($referralStatusInput: ReferralStatusInput!) {
    UpdateReferralStatus(referralStatusInput: $referralStatusInput) {
      id
      status
    }
  }
`;

const RespondToReferral = gql`
  mutation RespondToReferral($referralId: ID!, $action: ReferralResponseAction!, $reason: String) {
    acceptDeclineReferral(referralId: $referralId, action: $action, reason: $reason) {
      id
    }
  }
`;

export { UpdateReferralStatus, RespondToReferral };
